import React, { Component } from 'react';
import propTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { getDateFromHours } from 'helpers/_date-helpers';
import styles from './styles';
import DayInput from 'components/DayInput';
import DurationInput from 'components/DurationInput';
import TimeInput from 'components/TimeInput';
import { generateHoursObject, generateTravelTimeHours, isSelectedTimeValid } from 'helpers/helpers';
import _ from 'lodash';
import { connect } from 'react-redux';
import { getTimeFormat, DAY_PART } from 'common/dateFormatConfig';
class HoursBlock extends Component {
  state = {
    values: {
      dayStart: '0',
      hourStart: '1',
      minuteStart: '00',
      amPmStart: DAY_PART[0],
      dayEnd: '0',
      hourEnd: '1',
      minuteEnd: '00',
      amPmEnd: DAY_PART[0],
      travelTimeToHours: '0',
      travelTimeToMinutes: '0',
      travelTimeFromHours: '0',
      travelTimeFromMinutes: '0',
      isShowTT: false,
      isShowHours: false,
    },
    isValid: true,
    errors: [],
    originValues: null,
  };

  componentDidMount() {
    const { sheet, itemHours } = this.props;
    const getTimeFormatHook = (hourObj) =>
      getTimeFormat(hourObj, this.props.timeFormat, this.props.dateFormat);
    const hourObj = sheet.travelTimeOnly
      ? {}
      : generateHoursObject(itemHours?.start, itemHours?.end, sheet.createdAt, getTimeFormatHook);
    const travelTimesObj = generateTravelTimeHours(
      itemHours?.travelTimeTo,
      itemHours?.travelTimeFrom,
      '0'
    );

    this.setState((prevState) => ({
      values: {
        ...prevState.values,
        ...hourObj,
        ...travelTimesObj,
        isShowTT: !itemHours.isWlTravelTime,
        isShowHours: !itemHours.isWlHours,
      },
      originValues: { ...prevState.values, ...hourObj },
    }));
  }

  componentDidUpdate(prevProps) {
    if (_.isEqual(this.props, prevProps)) return;

    const { itemHours, sheet, reset } = this.props;
    const travelTimesObj = generateTravelTimeHours(
      itemHours?.travelTimeTo,
      itemHours?.travelTimeFrom
    );

    let hoursObj = {};
    if (reset !== null && !sheet.travelTimeOnly) {
      const getTimeFormatHook = (hourObj) => getTimeFormat(hourObj, this.props.timeFormat, this.props.dateFormat);
      hoursObj = generateHoursObject(itemHours?.start, itemHours?.end, sheet.createdAt, getTimeFormatHook);
    }

    // if (
    //   this.props?.itemHours?.isWlHours !== prevProps?.itemHours?.isWlHours ||
    //   this.props?.itemHours?.isWlTravelTime !== prevProps?.itemHours?.isWlTravelTime ||
    //   !_.isEqual(this.props, prevProps)
    // ) {
    this.setState((prevState) => ({
      values: {
        ...prevState.values,
        isShowHours: !this.props?.itemHours?.isWlHours,
        isShowTT: !this.props?.itemHours?.isWlTravelTime,
        ...hoursObj,
        ...travelTimesObj,
      },
    }));
    // }
    // else if (this.props?.itemHours?.isWlTravelTime !== prevProps?.itemHours?.isWlTravelTime) {
    //   this.setState((prevState) => ({
    //     values: {
    //       ...prevState.values,
    //       isShowTT: !this.props?.itemHours?.isWlTravelTime,
    //       ...travelTimesObj,
    //     },
    // }));
    // }
  }

  handleChange = (parts) => {
    const { updateResourceHours, itemHours, sheet, isEquipment } = this.props;
    const { values } = this.state;
    const getTimeFormatHook = (hourObj) =>
      getTimeFormat(hourObj, this.props.timeFormat, this.props.dateFormat);
    this.setState(
      (prevState) => ({
        values: { ...prevState.values, ...parts },
      }),
      () => {
        const { isValid, errorsOnFields } = isSelectedTimeValid(
          this.state.values,
          getTimeFormatHook,
          this.props.dateFormat,
        );

        this.setState({ isValid, errors: errorsOnFields });
        const { start, end, travelTimeTo, travelTimeFrom } = getDateFromHours(
          this.state.values,
          sheet.createdAt,
          getTimeFormatHook
        );
        if (isEquipment) {
          const updatedHours = {
            start,
            end,
          };
          if (itemHours?.id) updatedHours.id = itemHours.id;
          if (!isValid) {
            updatedHours.error = true;
          } else {
            delete updatedHours.error;
          }
          updateResourceHours(updatedHours);
        } else {
          const updatedHours = { ...itemHours, start, end, travelTimeTo, travelTimeFrom };
          if (!isValid) {
            updatedHours.error = true;
          } else {
            delete updatedHours.error;
          }
          if (!values.isShowHours && values.isShowTT) {
            delete updatedHours.start;
            delete updatedHours.end;
          }
          updateResourceHours(updatedHours);
        }
      }
    );
  };

  render() {
    const {
      classes,
      sheet,
      deleteTime,
      deleteTravelTime,
      itemHours,
      isWorkersType,
      isEquipment,
      isAnyCropped,
      itemData,
      hoursIndex,
    } = this.props;
    const { values, errors } = this.state;
    const canEdit = this.props.canEdit === undefined ? true : this.props.canEdit;
    const showStartHoursError = !!`${hoursIndex}`
      ? itemData?.errorData?.startHoursErrors?.[hoursIndex]
      : false;

    const hasError = (...fields) => fields.some((field) => errors.includes(field));

    // The parts stay strings, as the typed inputs kept them.
    const travelProps = (name) => ({
      title: 'Travel time',
      value: { hours: values[`${name}Hours`], minutes: values[`${name}Minutes`] },
      onChange: ({ hours, minutes }) =>
        this.handleChange({
          [`${name}Hours`]: String(hours),
          [`${name}Minutes`]: String(minutes),
        }),
      error: hasError(`${name}Hours`, `${name}Minutes`),
      maxHours: 24,
      disabled: !canEdit,
    });

    return (
      <div>
        {!sheet?.travelTimeOnly && values.isShowHours && (
          <div className={classes.flexBox}>
            <div style={{ width: '100%' }}>
              <div
                className={classnames(
                  classes.inlineFlex,
                  classes.rowWrapper,
                  classes.startTimeWrapper
                )}
              >
                <Typography
                  variant="body1"
                  color="textSecondary"
                  className={classnames(classes.regularFontWeight, classes.paddingBottom)}
                >
                  On Job Time:
                </Typography>
                <div className={classes.fields}>
                  <DayInput
                    value={values.dayStart}
                    onChange={(dayStart) => this.handleChange({ dayStart })}
                    baseDate={sheet.createdAt}
                    error={hasError('dayStart') || showStartHoursError}
                    disabled={!canEdit}
                  />
                  <TimeInput
                    value={{
                      hour: values.hourStart,
                      minute: values.minuteStart,
                      amPm: values.amPmStart,
                    }}
                    onChange={({ hour, minute, amPm }) =>
                      this.handleChange({ hourStart: hour, minuteStart: minute, amPmStart: amPm })
                    }
                    error={
                      hasError('hourStart', 'minuteStart', 'amPmStart') || showStartHoursError
                    }
                    disabled={!canEdit}
                  />
                </div>
              </div>
              <div className={classnames(classes.inlineFlex, classes.rowWrapper)}>
                <Typography
                  variant="body1"
                  color="textSecondary"
                  className={classnames(
                    classes.regularFontWeight,
                    classes.paddingBottom,
                    classes.mobileHidden
                  )}
                >
                  &nbsp;
                </Typography>
                <div className={classes.fields}>
                  <DayInput
                    value={values.dayEnd}
                    onChange={(dayEnd) => this.handleChange({ dayEnd })}
                    baseDate={sheet.createdAt}
                    error={hasError('dayEnd')}
                    disabled={!canEdit}
                  />
                  <TimeInput
                    value={{ hour: values.hourEnd, minute: values.minuteEnd, amPm: values.amPmEnd }}
                    onChange={({ hour, minute, amPm }) =>
                      this.handleChange({ hourEnd: hour, minuteEnd: minute, amPmEnd: amPm })
                    }
                    error={hasError('hourEnd', 'minuteEnd', 'amPmEnd')}
                    disabled={!canEdit}
                  />
                </div>
              </div>
            </div>

            <div className={classnames(classes.inlineFlex, isWorkersType && classes.reverseColumn)}>
              {canEdit ? (
                <IconButton
                  className={classnames(
                    classes.deleteButton,
                    classes.individualDeleteButton,
                    isWorkersType && classes.marginBottom
                  )}
                  onClick={deleteTime}
                  aria-label="Delete"
                  disableTouchRipple
                >
                  <CloseIcon />
                </IconButton>
              ) : <span style={{ width: '39px', height: '32px' }}></span>}
            </div>
          </div>
        )}
        {!isEquipment && values.isShowTT && (
          <div className={classnames(classes.rowWrapper, classes.travelTimeBlock)}>
            <>
              <div className={classnames(classes.travelInputsWrapper)}>
                <div
                  className={classnames(
                    classes.rowWrapper,
                    classes.travelTimeWrapper,
                    classes.startTimeWrapper
                  )}
                >
                  <div>
                    <Typography variant="body1" color="textSecondary">
                      Individual Time To:
                    </Typography>
                  </div>

                  <div className={classes.fields}>
                    <DurationInput {...travelProps('travelTimeTo')} />
                  </div>
                </div>
                <div className={classnames(classes.travelTimeWrapper, classes.startTimeWrapper)}>
                  <div>
                    <Typography variant="body1" color="textSecondary">
                      Individual Time From:
                    </Typography>
                  </div>

                  <div className={classes.fields}>
                    <DurationInput {...travelProps('travelTimeFrom')} />
                  </div>
                </div>
              </div>
              <IconButton
                className={classnames(
                  classes.deleteButton,
                  isWorkersType && classes.marginBottom,
                  (!canEdit || (isAnyCropped && values.isShowHours)) && classes.hidden
                )}
                onClick={deleteTravelTime}
                aria-label="Delete"
                disableTouchRipple
              >
                <CloseIcon />
              </IconButton>
            </>
          </div>
        )}
      </div>
    );
  }
}

HoursBlock.propTypes = {
  classes: propTypes.object.isRequired,
  itemHours: propTypes.object.isRequired,
  sheet: propTypes.object.isRequired,
  deleteTime: propTypes.func.isRequired,
  updateResourceHours: propTypes.func.isRequired,
  isWorkersType: propTypes.bool,
  hoursIndex: propTypes.number,
};

export default connect((state) => ({
  dateFormat: state.personalProfile.organization?.settings?.dateFormat,
  timeFormat: state.personalProfile.organization?.settings?.timeFormat,
}))(withStyles(styles)(HoursBlock));
